import {
    Box,
    Button,
    Checkbox,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
    ArrowDropDown,
    ArrowDropUp,
    ImportExportSharp,
} from "@material-ui/icons";
import InfoIcon from "@material-ui/icons/Info";
import { Autocomplete } from "@mui/material";
import Config from "Config";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Constant } from "../../Constant";
import { send } from "../../SendRequest";
import {
    capitalizeFirstLetter,
    downloadURLFile,
    getAdvSearchFeilds,
    getAdvSearchResultOffset,
    getEnquiryTitleParam,
    getFormTitleParam,
    getIsReleasedForm,
    getUserAgent,
    isEmpty,
    isNotEmpty,
    isObjectEmpty,
    isObjectNotEmpty,
    parseReferenceNumber,
} from "../../Utils";
import CustomDatePicker from "../../component/CustomDatePicker/CustomDatePicker";
import CustomSelect from "../../inputComponent/CustomSelect/CustomSelect";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { resetSearchData, setSearchData } from "../../redux/action";
import {
    getFormTitleParamList,
    getSearchData,
    getSelectedUserOrg,
} from "../../redux/selector";
import AlertDialog from "../AlertDialog/AlertDialog";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";

const useStyles = makeStyles({
    tableRow: {
        textDecoration: "none!important",
    },
    advSearchBox: {
        backgroundColor: "rgb(245, 245, 245)",
        padding: "5px",
    },
    customTable: {
        "& .MuiTableCell-sizeSmall": {
            padding: "5px",
        },
    },
});

function FormEnquiry() {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const initSearchData = useSelector(getSearchData());
    const [searchResult, setSearchResult] = useState({});
    const [form028Dialog, setForm028Dialog] = useState(false);
    const [form028UploadResultDialog, setForm028UploadResultDialog] =
        useState(false);
    const [form028SelectedUploadFile, setForm028SelectedUploadFile] =
        useState(null);
    const [form028UploadTipsOpen, setForm028UploadTipsOpen] = useState(false);
    const [form028UploadAllFail, setForm028UploadAllFail] = useState(false);
    const [form028UploadFileErrorCode, setForm028UploadFileErrorCode] =
        useState(null);
    const [form028UpdatedFailFormRefs, setForm028UpdatedFailFormRefs] =
        useState([]);
    const [total, setTotal] = useState(0);
    const [offset, setOffset] = useState(20);
    const [formStatus, setFormStatus] = useState(null);
    const [selectedFormStatus, setSelectedFormStatus] = useState({});
    const formTitleParam = useSelector(getFormTitleParamList());
    const [formSelectionList, setFormSelectionList] = useState([]);
    const [formSelectionFlag, setFormSelectionFlag] = useState(false);
    const [advSearchFormId, setAdvSearchFormId] = useState("");
    const [subjectOptions, setSubjectOptions] = useState({ "": "All" });
    const [sectionNameOptions, setFormNameOptions] = useState({});
    const [allSectionNameList, setAllSectionNameList] = useState([]);
    const [postSecondaryOptions, setPostSecondaryOptions] = useState({});
    const [subject, setSubject] = useState("");
    const [searchFormId, setSearchFormId] = useState("");
    const [sortingObject, setSortingObject] = useState([
        { attribute: "submission", order: "asc" },
        { attribute: "downloaded", order: "asc" },
    ]);
    const [defaultSorting, setDefaultSorting] = useState(0); // 0:Default 1:Submission 2:downloaded
    const isMobile = isNotEmpty(getUserAgent()) && getUserAgent() !== "Firefox";
    const sortingAttribute = (attr, order) => {
        switch (attr) {
            case "submission":
                setDefaultSorting(1);
                break;
            case "downloaded":
                setDefaultSorting(2);
                break;
        }
        setSortingObject((prevSortingObject) => {
            const updatedSortingObject = prevSortingObject.map((item) => {
                if (item.attribute === attr) {
                    const newOrder =
                        order !== undefined
                            ? order
                            : item.order === "desc"
                            ? "asc"
                            : "desc";
                    return { ...item, order: newOrder };
                }
                return { ...item, order: "asc" };
            });

            // Sort the updatedSortingObject to ensure "asc" comes first
            updatedSortingObject.sort((a, b) => {
                if (a.order === "asc" && b.order === "desc") {
                    return -1;
                } else if (a.order === "desc" && b.order === "asc") {
                    return 1;
                } else {
                    return 0;
                }
            });

            return updatedSortingObject;
        });
    };

    const selectedUserOrg = useSelector(getSelectedUserOrg());
    const isEDBUser = selectedUserOrg?.type === "E";

    const [page, setPage] = useState(initSearchData?.page || 0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [selected, setSelected] = React.useState([]);
    const [res, setRes] = useState([]);
    const [edbCheckOpen, setEdbCheckOpen] = useState(false);
    const [noItemsPopup, setNoItemsPopup] = useState(false);
    const [dateValidationPopup, setDateValidationPopup] = useState(false);
    const [formId, setFormId] = useState(
        (initSearchData && initSearchData.formId) || { formId: "", name: "" }
    );
    const navigate = useNavigate();
    const batchDownloadLists = isEDBUser ? Constant?.batchDownloadForm : []; //Just EDB can use batch download function
    const isIncludeBatchDownload = (formId) => {
        if (!batchDownloadLists) return true;
        return batchDownloadLists.includes(formId);
    };
    const edbCheckForm = [
        "2",
        "3",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "19",
        "21",
        "22",
        "23",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "40",
        "43",
        "44",
        "45",
        "46",
        "48",
        "49",
        "52",
        "53",
        "54",
        "57",
        "58",
        "59",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "70",
        "71",
        "72",
        "73",
        "74",
        "75",
        "78",
        "80",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "88",
        "89",
        "90",
        "91",
        "92",
        "93",
        "94",
        "95",
        "99",
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setValue("startPage", newPage + 1);
        fetchData();
    };
    let data = {};

    const initialDefaultValues = {
        scrn: "",
        submissionTime: "",
        treaSchlCode: "",
        schoolName: "",
        applicantName: "",
        schlLevlType: "",
        schlFinanceTpye: "",
        submissionDateFrom: "",
        submissionDateTo: "",
        jobTitle: "",
        subject: "",
        amended: "",
        sectionName: "",
        groupName: "",
        rejectedBy: "",
        telNo: "",
    };

    let advanceSearch = isObjectNotEmpty(initSearchData)
        ? initSearchData
        : initialDefaultValues;

    const { control, getValues, setValue, register, watch, reset } = useForm({
        defaultValues: advanceSearch,
    });

    function fetchFormStatus() {
        const lang = i18n.language;
        const option = {
            url: `${Config.CONTENT_PATH}/form/getAllStatus/${lang}`,
        };
        dispatch(send("GET_FORM_STATUS", option))
            .then((response) => response.json())
            .then(
                (result) => {
                    // console.log(JSON.stringify(result));
                    setFormStatus(result);
                },
                (error) => {
                    console.log("error:" + error.message);
                }
            );
    }

    function fetchData(shouldResetSearchData) {
        if (shouldResetSearchData) {
            setDefaultSorting(0);
            setSortingObject([
                { attribute: "submission", order: "asc" },
                { attribute: "downloaded", order: "asc" },
            ]);
        }
        data = { ...getValues() };
        data[`formId`] = formId?.formId;
        if (isEDBUser && data[`formId`]) {
            data[`offset`] = getAdvSearchResultOffset(data[`formId`]);
        } else {
            data[`offset`] = 20;
        }
        if (
            !(shouldResetSearchData || defaultSorting === 0) &&
            isEDBUser &&
            isIncludeBatchDownload(data["formId"])
        ) {
            data["sorting"] = sortingObject.filter((obj) => {
                if (defaultSorting === 1) {
                    // Return objects with attribute "submission"
                    return obj.attribute === "submission";
                } else if (defaultSorting === 2) {
                    // Return objects with attribute "downloaded"
                    return obj.attribute === "downloaded";
                }
            });
        }
        //data["formId"] === "Form028" ? setValue("sorting", sortingObject) : setValue("sorting",null)
        //Form 28 sorting end

        if (data["formId"] === "Form098" && data["status"] === "10") {
            data["status"] = 3;
        }

        data["selectedScrn"] = selectedUserOrg?.scrn || null;

        const option = {
            url: `${Config.CONTENT_PATH}/workflow/search`,
            method: "POST",
            body: JSON.stringify(data),
        };
        dispatch(send("SEND_FORM_ENQUIRY", option))
            .then((response) => response.json())
            .then(
                (searchResult) => {
                    if (
                        isNotEmpty(getAdvSearchFeilds(data[`formId`])) ||
                        isIncludeBatchDownload(data["formId"])
                    ) {
                        setAdvSearchFormId(data[`formId`]);
                    } else {
                        setAdvSearchFormId("");
                    }
                    setSearchFormId(data[`formId`]);
                    setSearchResult(searchResult?.result);
                    setTotal(searchResult?.total);
                    setOffset(searchResult.offset);
                    if (shouldResetSearchData) {
                        dispatch(resetSearchData());
                    }
                },
                (error) => {
                    console.log("error:" + error.message);
                }
            );
    }

    function fetchFormSelectionList() {
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/getFormSelectionList`,
            method: "POST",
        };
        dispatch(send("GET_FORM_SELECTION_LIST", option))
            .then((response) => response.json())
            .then(
                (data) => {
                    setFormSelectionList(data);
                    setFormSelectionFlag(true);
                },
                (error) => {
                    setFormSelectionFlag(false);
                    console.log("error:" + error.message);
                }
            );
    }

    const handleFormData = () => {
        let arr = Object.entries(t("form", { returnObjects: true, lng: "en" }))
            .map((r) => {
                return {
                    formId: r[0],
                    name: t(
                        `form.${r[0]}`,
                        getFormTitleParam(r[0], formTitleParam, i18n.language)
                    ),
                };
            })
            //filter the released form
            .filter((r) => {
                return getIsReleasedForm(r.formId);
            });
        return arr;
    };

    // useEffect(() => {
    //     fetchFormSelectionList();
    //     let obj = handleFormData();
    //     if (formSelectionList?.[0] && formSelectionList?.[0] === "AllForm") {
    //         setRes(obj);
    //     } else {
    //         let data = obj.filter((item) => {
    //             return formSelectionList?.includes(item.formId);
    //         });
    //         setRes(data);
    //     }
    // }, [t]);

    useEffect(() => {
        fetchFormSelectionList();
        if (formId?.formId === "Form105") {
            fetchFormNameList();
        }
    }, [t]);

    useEffect(() => {
        let obj = handleFormData();
        if (formSelectionList?.[0] && formSelectionList?.[0] === "AllForm") {
            setRes(obj);
        } else {
            let data = obj.filter((item) => {
                return formSelectionList?.includes(item.formId);
            });
            setRes(data);
        }
    }, [t, formTitleParam, formSelectionFlag]);

    let zipData = {};

    function getZip() {
        let obj = {};
        if (isIncludeBatchDownload(searchFormId)) {
            if (isObjectEmpty(selected)) {
                //TODO
                setNoItemsPopup(true);
                return;
            } else if (!isObjectEmpty(searchResult)) {
                selected.forEach((ref) => {
                    const parseRef = parseReferenceNumber(ref);
                    const formId = parseRef?.formId
                        ?.replace("Form0", "")
                        ?.replace("Form", "");
                    if (!obj[formId]) {
                        obj[formId] = [];
                    }
                    obj[formId].push(Number(parseRef.id));
                    Object.keys(obj).map(function (k) {
                        return (zipData[k] = obj[k]);
                    });
                });
            }
        } else {
            if (!isObjectEmpty(searchResult)) {
                searchResult.forEach(function (item) {
                    if (!obj[item.formId]) obj[item.formId] = [];
                    obj[item.formId].push(Number(item.refNum));
                });
                Object.keys(obj).map(function (k) {
                    return (zipData[k] = obj[k]);
                });
            }
        }

        const option = {
            url: `${Config.CONTENT_PATH}/workflow/zip`,
            method: "POST",
            body: JSON.stringify(zipData),
            header: {
                Accept: "application/zip",
            },
        };
        let filename = `eformss_${moment().format("MM_DD_YYYY[.zip]")}`;
        dispatch(send("DOWNLOAD_ZIP", option))
            .then((res) => {
                const contentDisposition = res.headers.get(
                    "content-disposition"
                );
                if (contentDisposition) {
                    const [_, temp] = contentDisposition.split("filename=");
                    if (!temp) {
                        console.error("Filename is null or undefined");
                    } else {
                        filename = temp;
                    }
                }
                return res.blob();
            })
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = filename;
                aTag.click();
                URL.revokeObjectURL(result);
                handleChangePage(null, page);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function getExcelZip() {
        // Perform date validation
        const submissionDateFrom = watch("submissionDateFrom");
        const submissionDateTo = watch("submissionDateTo");

        if (isEmpty(submissionDateFrom) || isEmpty(submissionDateTo)) {
            setDateValidationPopup(true);
            return;
        }

        if (
            moment(submissionDateTo).diff(
                moment(submissionDateFrom),
                "years",
                true
            ) >= 1
        ) {
            setDateValidationPopup(true);
            return;
        }

        const data = { ...getValues() };
        data[`formId`] = formId?.formId;
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/getExcelByPeriod`,
            method: "POST",
            body: JSON.stringify(data),
            header: {
                Accept: "application/zip",
            },
        };
        let filename = `eformss_${moment().format("MM_DD_YYYY[.zip]")}`;
        dispatch(send("DOWNLOAD_ZIP", option))
            .then((res) => {
                const contentDisposition = res.headers.get(
                    "content-disposition"
                );
                if (contentDisposition) {
                    const [_, temp] = contentDisposition.split("filename=");
                    if (!temp) {
                        console.error("Filename is null or undefined");
                    } else {
                        filename = temp;
                    }
                }
                return res.blob();
            })
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = filename;
                aTag.click();
                URL.revokeObjectURL(result);
                handleChangePage(null, page);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getFullExcel = () => {
        data = { ...getValues() };
        data[`formId`] = formId?.formId;
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/formFullExcel`,
            method: "POST",
            body: JSON.stringify(data),
            header: {
                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
        };
        dispatch(send("DOWNLOAD_FULL_EXCEL", option))
            .then((res) => {
                const filename = res.headers
                    .get("Content-Disposition")
                    .split("filename=")[1];
                res.blob().then((result) => {
                    let aTag = document.createElement("a");
                    aTag.href = URL.createObjectURL(result);
                    aTag.download = filename;
                    aTag.click();
                    URL.revokeObjectURL(result);
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getForm107Zip = () => {
        data = { ...getValues() };
        data[`formId`] = formId?.formId;
        const option = {
            url: `${Config.CONTENT_PATH}/workflow/formForm107Excel`,
            method: "POST",
            body: JSON.stringify(data),
            header: {
                Accept: "application/zip",
            },
        };
        dispatch(send("DOWNLOAD_FORM107_ZIP", option))
            .then((res) => {
                const filename = res.headers
                    .get("Content-Disposition")
                    .split("filename=")[1];
                res.blob().then((result) => {
                    let aTag = document.createElement("a");
                    aTag.href = URL.createObjectURL(result);
                    aTag.download = filename;
                    aTag.click();
                    URL.revokeObjectURL(result);
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const uploadFiles = (file) => {
        if (!file) return;

        const formData = new FormData();
        formData.append("formRefExcel", file);

        const option = {
            url: `${Config.CONTENT_PATH}/form028/batchReviewByExcel`,
            method: "POST",
            body: formData,
        };

        dispatch(send("SUBMIT_ATTACHMENT", option))
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    const failedFormRefs = result.data
                        .filter((item) => !item.success)
                        .map((item) => item.formRef);
                    setForm028UpdatedFailFormRefs(failedFormRefs);
                } else {
                    const errorCode = result?.code || "unknown";
                    setForm028UploadFileErrorCode(
                        t(`errorMsg.batchUpdate.${errorCode}`)
                    );
                    setForm028UploadAllFail(true);
                }
                setForm028Dialog(false);
                setForm028UploadResultDialog(true);
                setForm028SelectedUploadFile(null);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
                setForm028UploadFileErrorCode(t(`errorMsg.unknownError`));
                setForm028UploadAllFail(true);
                setForm028SelectedUploadFile(null);
            });
    };

    function getProgressReport() {
        const option = {
            url: `${Config.CONTENT_PATH}/form104/genForm104Excel`,
            method: "GET",
        };
        let filename = `eformss_${moment().format("MM_DD_YYYY[.excel]")}`;
        dispatch(send("DOWNLOAD_ZIP", option))
            .then((res) => {
                const contentDisposition = res.headers.get(
                    "content-disposition"
                );
                if (contentDisposition) {
                    const [_, temp] = contentDisposition.split("filename=");
                    if (!temp) {
                        console.error("Filename is null or undefined");
                    } else {
                        filename = temp;
                    }
                }
                return res.blob();
            })
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = filename;
                aTag.click();
                URL.revokeObjectURL(result);
                handleChangePage(null, page);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        fetchFormStatus();
        if (isObjectEmpty(initSearchData)) {
            setValue("startPage", 1);
        } else {
            setPage(Number(getValues("startPage")) - 1);
        }
        fetchData(true);
    }, []);

    useEffect(() => {
        fetchFormStatus();
    }, [i18n.language]);

    useEffect(() => {
        const formName = res.find((form) => form?.formId === formId?.formId);
        if (formName) {
            setFormId(formName);
        }
    }, [res]);

    const onSubmit = () => {
        setValue("startPage", 1);
        fetchData(true);
        setPage(0);
    };

    useEffect(() => {
        if (defaultSorting != 0) {
            setValue("startPage", 1);
            setPage(0);
            fetchData();
        }
    }, [sortingObject]);

    function fetchSelectedFormStatus() {
        if (isObjectNotEmpty(formStatus)) {
            const allowed = ["0", "2", "4", "6", "8", "10", "20", "21", "22"];
            if (isNotEmpty(formId?.formId)) {
                const formIdx = parseInt(formId?.formId?.replace("Form", ""));

                if (Object.keys(formStatus).includes(formIdx.toString())) {
                    const filtered = Object.fromEntries(
                        Object.entries(formStatus[formIdx]).filter(
                            ([key, value]) => allowed.includes(key)
                        )
                    );
                    setSelectedFormStatus(filtered);
                } else {
                    const filtered = Object.fromEntries(
                        Object.entries(formStatus["common"]).filter(
                            ([key, value]) => allowed.includes(key)
                        )
                    );
                    setSelectedFormStatus(filtered);
                }
            } else {
                const filtered = Object.fromEntries(
                    Object.entries(formStatus["common"]).filter(
                        ([key, value]) => allowed.includes(key)
                    )
                );
                setSelectedFormStatus(filtered);
            }
        }
    }
    function getStatusPerForm(formId, status) {
        if (formStatus != null) {
            if (
                Object.keys(formStatus).includes(formId) &&
                formStatus[formId][status] !== undefined
            ) {
                return formStatus[formId][status];
            } else {
                return formStatus["common"][status];
            }
        } else {
            return t(`common.status.${status}`);
        }
    }

    useEffect(() => {
        fetchSelectedFormStatus();
    }, [formStatus, formId]);

    function getForm101JobParam() {
        let key;
        switch (i18n.language) {
            case "en":
                key = "jobApplicationEN";
                break;
            case "tc":
                key = "jobApplicationTC";
                break;
            case "sc":
                key = "jobApplicationSC";
                break;
        }
        return isNotEmpty(formTitleParam[101][key])
            ? JSON.parse(formTitleParam[101][key])
            : {};
    }

    function form101JobOption() {
        let jobs = { "": t("common.portal.all") };
        Object.assign(jobs, getForm101JobParam()?.jobOptions);
        return jobs;
    }

    function form101SubjectOption(jobTitle) {
        let subjects = { "": t("common.portal.all") };
        Object.assign(subjects, getForm101JobParam()[`${jobTitle}Options`]);
        return subjects;
    }

    const handleToDetail = (item) => {
        if (item?.viewPermission) {
            let searchData = {
                ...getValues(),
                formId,
            };
            dispatch(setSearchData(searchData));
            navigate(
                `/approval/Form${item.formId.padStart(3, "0")}/${
                    item.formRefNum
                }`
            );
        } else {
            setEdbCheckOpen(true);
        }
        // if (isEDBUser && edbCheckForm.includes(item.formId)) {
        //     if (
        //         item.status == "9" ||
        //         item.status == "10" ||
        //         item.status == "20"
        //     ) {
        //         navigate(
        //             `/approval/Form${item.formId.padStart(3, "0")}/${
        //                 item.formRefNum
        //             }`
        //         );
        //     } else {
        //         setEdbCheckOpen(true);
        //     }
        // } else {
        //     navigate(
        //         `/approval/Form${item.formId.padStart(3, "0")}/${
        //             item.formRefNum
        //         }`
        //     );
        // }
    };

    const signatureTypeOption = t("common.signatureTypeOption", {
        returnObjects: true,
    });

    const rejectedOptions = t("common.portal.rejectedOptions", {
        returnObjects: true,
    });

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            //Filter viewPermission = true for select
            const newSelected = searchResult
                .filter((item) => item.viewPermission === true)
                .map((item) => item.formRefNum);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const isSelected = (formRefNum) => selected.indexOf(formRefNum) !== -1;

    const handleClick = (event, formRefNum) => {
        const selectedIndex = selected.indexOf(formRefNum);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, formRefNum);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    useEffect(() => {
        setSelected([]);
    }, [searchResult]);

    useEffect(() => {
        if (formId?.formId === "Form105") {
            if (isObjectEmpty(sectionNameOptions)) {
                fetchFormNameList();
            }
        }
        if (formId?.formId === "Form107") {
            if (isObjectEmpty(postSecondaryOptions)) {
                fetchPostSecondaryList();
            }
        }
    }, [formId]);

    const hasRowValue = (item) => {
        const advSearchFeilds = getAdvSearchFeilds(advSearchFormId);
        return advSearchFeilds?.find((key) => isNotEmpty(item?.[key]));
    };

    const fetchFormNameList = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/getSectionSearchSelection`,
            method: "GET",
        };
        dispatch(send("GET_COLLBOX_FORM_NAME", option))
            .then((response) => response.json())
            .then(
                (result) => {
                    if (result?.success === true) {
                        const obj = {};
                        result?.data?.forEach((form) => {
                            obj[form.id] =
                                form?.[
                                    `sectionName${capitalizeFirstLetter(
                                        i18n.language
                                    )}`
                                ];
                        });
                        setFormNameOptions(obj);
                        setAllSectionNameList(result?.data);
                    }
                },
                (error) => {
                    console.log("error:" + error.message);
                }
            );
    };

    const fetchPostSecondaryList = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/getPostSecondaryDropDown`,
            method: "GET",
        };
        dispatch(send("GET_POST_SECONDARY_LIST", option))
            .then((response) => response.json())
            .then(
                (result) => {
                    if (result && Array.isArray(result)) {
                        const obj = {};
                        result.forEach((school) => {
                            obj[school.id] = school.name;
                        });
                        setPostSecondaryOptions(obj);
                    }
                },
                (error) => {
                    console.log("error:" + error.message);
                }
            );
    };

    useEffect(() => {
        if (
            isObjectNotEmpty(selectedUserOrg) &&
            isNotEmpty(selectedUserOrg?.scrn)
        ) {
            fetchData(true);
        }
    }, [selectedUserOrg]);

    return (
        <Container maxWidth="md">
            <AlertDialog
                formOpen={edbCheckOpen}
                content={t(`errorMsg.edbCheckFormPop`)}
                confirmButton={{
                    action: () => {
                        setEdbCheckOpen(false);
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={noItemsPopup}
                content={t(`errorMsg.noItemsPopup`)}
                confirmButton={{
                    action: () => {
                        setNoItemsPopup(false);
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={dateValidationPopup}
                content={t(`errorMsg.dateValidationPopup`)}
                confirmButton={{
                    action: () => {
                        setDateValidationPopup(false);
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />

            <Header
                headerTitle={t("common.portal.Enquiry")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main
                    className="main"
                    style={{ minWidth: 0, maxWidth: "100%" }}
                >
                    <Box style={{ marginLeft: "15px" }}>
                        <Box>
                            {!selectedUserOrg?.isPostSecondary && (
                                <Box display="flex">
                                    <InputLabel
                                        htmlFor="formName"
                                        style={{
                                            alignSelf: "center",
                                            width:
                                                i18n.language === "en"
                                                    ? "18%"
                                                    : "12%",
                                        }}
                                    >
                                        {t("common.portal.formName")}
                                        {t("common.colon")}
                                    </InputLabel>
                                    <Autocomplete
                                        id="formName"
                                        style={{ width: "80%" }}
                                        options={res.sort((a, b) => {
                                            let akey = a.formId.slice(4);
                                            let bkey = b.formId.slice(4);
                                            return -bkey.localeCompare(akey, {
                                                numeric: "true",
                                            });
                                        })}
                                        getOptionLabel={(option) => {
                                            return option.name;
                                        }}
                                        groupBy={(option) => option.formId}
                                        onChange={(e, newValue) => {
                                            setFormId(newValue);
                                            const advSearchFeilds =
                                                getAdvSearchFeilds(
                                                    newValue?.formId
                                                );
                                            const oldAdvSearchFeilds =
                                                getAdvSearchFeilds(
                                                    formId?.formId
                                                );
                                            const resetData =
                                                Object.keys(
                                                    initialDefaultValues
                                                );
                                            resetData.forEach((key) => {
                                                if (
                                                    !advSearchFeilds.find(
                                                        (feild) => feild === key
                                                    )
                                                ) {
                                                    setValue(key, "");
                                                }
                                            });

                                            //Form101 reset subject
                                            setSubject("");
                                            setSubjectOptions(
                                                form101SubjectOption("")
                                            );
                                            oldAdvSearchFeilds.forEach(
                                                (key) => {
                                                    setValue(key, "");
                                                }
                                            );
                                        }}
                                        value={formId}
                                        blurOnSelect
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <div {...props} key={option.formId}>
                                                {option.name}
                                            </div>
                                        )}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.formId === value?.formId
                                        }
                                    />
                                </Box>
                            )}
                            <Box display="flex">
                                <InputLabel
                                    htmlFor="formRefNum"
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                >
                                    {(isEDBUser &&
                                        formId?.formId === "Form107") ||
                                    selectedUserOrg?.isPostSecondary
                                        ? t("common.portal.batchNumber")
                                        : t("common.portal.referenceNum")}
                                    {t("common.colon")}
                                </InputLabel>
                                <CustomTextField
                                    id="formRefNum"
                                    inputProps={{
                                        ...register("formRefNum"),
                                    }}
                                />
                            </Box>
                            <Box display="flex" marginY={3}>
                                <InputLabel
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                >
                                    {t("common.portal.submissionDate")}
                                    {i18n.language === "en" ? " " : ""}
                                </InputLabel>

                                <InputLabel
                                    htmlFor="submissionDateFrom"
                                    style={{
                                        marginRight: "2%",
                                    }}
                                >
                                    {t("common.from")}
                                    {t("common.colon")}
                                </InputLabel>
                                <CustomDatePicker
                                    control={control}
                                    name="submissionDateFrom"
                                    type="day"
                                    isAutofillOff="off"
                                    maxDate={
                                        isNotEmpty(watch("submissionDateTo"))
                                            ? new Date(
                                                  watch("submissionDateTo")
                                              )
                                            : new Date()
                                    }
                                />

                                <InputLabel
                                    htmlFor="submissionDateTo"
                                    style={{
                                        alignSelf: "center",
                                        marginLeft: "5%",
                                        marginRight: "2%",
                                        width: "6%",
                                    }}
                                >
                                    {t("common.to")}
                                    {t("common.colon")}
                                </InputLabel>
                                <CustomDatePicker
                                    control={control}
                                    name="submissionDateTo"
                                    type="day"
                                    maxDate={new Date()}
                                    minDate={
                                        new Date(watch("submissionDateFrom"))
                                    }
                                    isAutofillOff="off"
                                />
                            </Box>
                            <Box display="flex">
                                <Box
                                    style={{
                                        alignSelf: "center",
                                        width:
                                            i18n.language === "en"
                                                ? "18%"
                                                : "12%",
                                    }}
                                    component="span"
                                >
                                    {t("common.portal.status")}
                                    {t("common.colon")}
                                </Box>
                                <Controller
                                    control={control}
                                    name="status"
                                    render={({ field }) => (
                                        <FormControl
                                            id="Category"
                                            style={{ width: "50%" }}
                                        >
                                            <Select
                                                label="Category"
                                                inputProps={{
                                                    "aria-labelledby":
                                                        "Category",
                                                }}
                                                value={field.value || ""}
                                                displayEmpty
                                                onChange={(e) => {
                                                    field.onChange(
                                                        e.target.value
                                                    );
                                                }}
                                                disabled={isNotEmpty(
                                                    watch("rejectedBy")
                                                )}
                                            >
                                                <MenuItem value="">
                                                    {t("common.portal.all")}
                                                </MenuItem>
                                                {isObjectNotEmpty(
                                                    selectedFormStatus
                                                ) &&
                                                    Object.entries(
                                                        selectedFormStatus
                                                    ).map(([key, value]) => (
                                                        <MenuItem
                                                            value={key}
                                                            key={key}
                                                        >
                                                            {key === "10" &&
                                                            formId?.formId !==
                                                                "Form103" &&
                                                            formId?.formId !==
                                                                "Form102" &&
                                                            formId?.formId !==
                                                                "Form089"
                                                                ? value +
                                                                  " " +
                                                                  t(
                                                                      "common.slash"
                                                                  ) +
                                                                  " " +
                                                                  t(
                                                                      "common.statusEDBPendingReceive"
                                                                  )
                                                                : value}
                                                        </MenuItem>
                                                    ))}
                                                {/* <MenuItem value=""> </MenuItem>
                                <MenuItem value="0">
                                    {t("common.status.0")}
                                </MenuItem>
                                <MenuItem value="2">
                                    {t("common.status.2")}
                                </MenuItem>
                                <MenuItem value="4">
                                    {t("common.status.4")}
                                </MenuItem>
                                <MenuItem value="6">
                                    {t("common.status.6")}
                                </MenuItem>
                                <MenuItem value="10">
                                    {t("common.status.10")}
                                </MenuItem>
                                <MenuItem value="11">
                                    {t("common.status.11")}
                                </MenuItem> */}
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                            </Box>
                            {isEDBUser && (
                                <Box paddingTop={"5px"} paddingRight={"5px"}>
                                    <Box display="flex">
                                        <InputLabel
                                            htmlFor="downloaded"
                                            style={{
                                                alignSelf: "center",
                                                width:
                                                    i18n.language === "en"
                                                        ? "18%"
                                                        : "12%",
                                                wordBreak: isMobile
                                                    ? "break-word"
                                                    : "",
                                            }}
                                        >
                                            {t("common.downloaded")}
                                            {t("common.colon")}
                                        </InputLabel>
                                        <Box style={{ width: "62.5%" }}>
                                            <Controller
                                                control={control}
                                                name="downloaded"
                                                render={({ field }) => (
                                                    <FormControl
                                                        id="downloaded"
                                                        style={{ width: "50%" }}
                                                    >
                                                        <Select
                                                            label="downloaded"
                                                            inputProps={{
                                                                "aria-labelledby":
                                                                    "downloaded",
                                                            }}
                                                            value={field.value}
                                                            displayEmpty
                                                            native
                                                            onChange={(e) => {
                                                                field.onChange(
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                        >
                                                            {Object.entries(
                                                                t(
                                                                    "common.downloadedOption",
                                                                    {
                                                                        returnObjects: true,
                                                                    }
                                                                )
                                                            ).map(
                                                                ([
                                                                    key,
                                                                    value,
                                                                ]) => (
                                                                    <option
                                                                        value={
                                                                            key
                                                                        }
                                                                        key={
                                                                            key
                                                                        }
                                                                    >
                                                                        {value}
                                                                    </option>
                                                                )
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            )}

                            {isEDBUser &&
                                isObjectNotEmpty(formId?.formId) &&
                                isObjectNotEmpty(
                                    getAdvSearchFeilds(formId?.formId)
                                ) && (
                                    <Box className={classes.advSearchBox}>
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("scrn") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="scrn"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {formId?.formId ===
                                                    "Form104"
                                                        ? t(
                                                              "Form104.label.scrn"
                                                          )
                                                        : t(
                                                              "common.portal.scrn"
                                                          )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="scrn"
                                                    inputProps={{
                                                        ...register("scrn"),
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("submissionTime") && (
                                            <Box display="flex" marginY={3}>
                                                <InputLabel
                                                    htmlFor="submissionTime"
                                                    style={{
                                                        alignSelf: "center",
                                                        marginTop: "3px",

                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.submissionDate"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomDatePicker
                                                    control={control}
                                                    name="submissionTime"
                                                    type="day"
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("treaSchlCode") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="treaSchlCode"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.schoolCode"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="treaSchlCode"
                                                    inputProps={{
                                                        ...register(
                                                            "treaSchlCode"
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("nameOfContributorEN") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="nameOfContributorEN"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "30%"
                                                                : "20%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.nameOfContributorEN"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="nameOfContributorEN"
                                                    inputProps={{
                                                        ...register(
                                                            "nameOfContributorEN"
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("nameOfContributorCH") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="nameOfContributorCH"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "30%"
                                                                : "20%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.nameOfContributorCH"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="nameOfContributorCH"
                                                    inputProps={{
                                                        ...register(
                                                            "nameOfContributorCH"
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("telNo") &&
                                            (formId?.formId === "Form092" ||
                                                formId?.formId ===
                                                    "Form095") && (
                                                <Box display="flex">
                                                    <InputLabel
                                                        htmlFor="telNo"
                                                        style={{
                                                            alignSelf: "center",
                                                            width:
                                                                i18n.language ===
                                                                "en"
                                                                    ? "18%"
                                                                    : "12%",
                                                        }}
                                                    >
                                                        {t("common.telNo")}
                                                        {t("common.colon")}
                                                    </InputLabel>
                                                    <CustomTextField
                                                        id="telNo"
                                                        inputProps={{
                                                            ...register(
                                                                "telNo"
                                                            ),
                                                        }}
                                                    />
                                                </Box>
                                            )}

                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("schoolName") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="schoolName"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "15%",
                                                    }}
                                                >
                                                    {formId?.formId ===
                                                        "Form092" ||
                                                    formId?.formId === "Form095"
                                                        ? t(
                                                              "common.lastSchoolOfEmployment"
                                                          )
                                                        : t(
                                                              "common.schoolName"
                                                          )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="schoolName"
                                                    inputProps={{
                                                        ...register(
                                                            "schoolName"
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("staffNo") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="staffNo"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t("common.staffNo")}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="staffNo"
                                                    inputProps={{
                                                        ...register("staffNo"),
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("telNo") &&
                                            formId?.formId === "Form075" && (
                                                <Box display="flex">
                                                    <InputLabel
                                                        htmlFor="telNo"
                                                        style={{
                                                            alignSelf: "center",
                                                            width:
                                                                i18n.language ===
                                                                "en"
                                                                    ? "18%"
                                                                    : "12%",
                                                        }}
                                                    >
                                                        {t(
                                                            "common.portal.schltele"
                                                        )}
                                                        {t("common.colon")}
                                                    </InputLabel>
                                                    <CustomTextField
                                                        id="telNo"
                                                        inputProps={{
                                                            ...register(
                                                                "telNo"
                                                            ),
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("applicantName") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="applicantName"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.applicantName"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="applicantName"
                                                    inputProps={{
                                                        ...register(
                                                            "applicantName"
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("schltele") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="schltele"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.schltele"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="schltele"
                                                    inputProps={{
                                                        ...register("schltele"),
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("schlLevlType") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="schlLevlType"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.schoolLevel"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "62.5%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="schlLevlType"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="schlLevlType"
                                                                style={{
                                                                    width: "50%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="schlLevlType"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "schlLevlType",
                                                                    }}
                                                                    value={
                                                                        field.value ||
                                                                        ""
                                                                    }
                                                                    displayEmpty
                                                                    native
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }}
                                                                >
                                                                    {Object.entries(
                                                                        t(
                                                                            "common.schoolLevelOption",
                                                                            {
                                                                                returnObjects: true,
                                                                            }
                                                                        )
                                                                    ).map(
                                                                        ([
                                                                            key,
                                                                            value,
                                                                        ]) => (
                                                                            <option
                                                                                value={
                                                                                    key
                                                                                }
                                                                                key={
                                                                                    key
                                                                                }
                                                                            >
                                                                                {
                                                                                    value
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("schlFinanceTpye") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="schlFinanceType"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.financeType"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "62.5%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="schlFinanceType"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="schlFinanceType"
                                                                style={{
                                                                    width: "50%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="schlFinanceType"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "schlFinanceType",
                                                                    }}
                                                                    value={
                                                                        field.value ||
                                                                        ""
                                                                    }
                                                                    displayEmpty
                                                                    native
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }}
                                                                >
                                                                    {Object.entries(
                                                                        t(
                                                                            "common.fullSchoolFinanceTypeOption",
                                                                            {
                                                                                returnObjects: true,
                                                                            }
                                                                        )
                                                                    ).map(
                                                                        ([
                                                                            key,
                                                                            value,
                                                                        ]) => (
                                                                            <option
                                                                                value={
                                                                                    key
                                                                                }
                                                                                key={
                                                                                    key
                                                                                }
                                                                            >
                                                                                {
                                                                                    value
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("downloaded") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="downloaded"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t("common.downloaded")}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "62.5%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="downloaded"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="downloaded"
                                                                style={{
                                                                    width: "50%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="downloaded"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "downloaded",
                                                                    }}
                                                                    value={
                                                                        field.value ||
                                                                        ""
                                                                    }
                                                                    displayEmpty
                                                                    native
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .targetf
                                                                                .value
                                                                        );
                                                                    }}
                                                                >
                                                                    {Object.entries(
                                                                        t(
                                                                            "common.downloadedOption",
                                                                            {
                                                                                returnObjects: true,
                                                                            }
                                                                        )
                                                                    ).map(
                                                                        ([
                                                                            key,
                                                                            value,
                                                                        ]) => (
                                                                            <option
                                                                                value={
                                                                                    key
                                                                                }
                                                                                key={
                                                                                    key
                                                                                }
                                                                            >
                                                                                {
                                                                                    value
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("ngoNameEng") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="ngoNameEng"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "25%"
                                                                : "23%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.ngoNameEng"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="ngoNameEng"
                                                    inputProps={{
                                                        ...register(
                                                            "ngoNameEng"
                                                        ),
                                                    }}
                                                    style={{ width: "70%" }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("ngoNameChi") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="ngoNameChi"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "25%"
                                                                : "23%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.ngoNameChi"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <CustomTextField
                                                    id="ngoNameChi"
                                                    inputProps={{
                                                        ...register(
                                                            "ngoNameChi"
                                                        ),
                                                    }}
                                                    style={{ width: "70%" }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("coordinatorName") && (
                                            <Box
                                                display="flex"
                                                alignItems="baseline"
                                            >
                                                <InputLabel
                                                    htmlFor="coordinatorName"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "30%"
                                                                : "13%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.coordinatorName"
                                                    )}
                                                </InputLabel>
                                                <Box marginRight={2}>
                                                    {t("common.colon")}
                                                </Box>
                                                <CustomTextField
                                                    id="coordinatorName"
                                                    inputProps={{
                                                        ...register(
                                                            "coordinatorName"
                                                        ),
                                                    }}
                                                    style={{ width: "65%" }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("coordinatorTelNo") && (
                                            <Box
                                                display="flex"
                                                alignItems="baseline"
                                            >
                                                <InputLabel
                                                    htmlFor="coordinatorTelNo"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "30%"
                                                                : "13%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.coordinatorTelNo"
                                                    )}
                                                </InputLabel>
                                                <Box marginRight={2}>
                                                    {t("common.colon")}
                                                </Box>
                                                <CustomTextField
                                                    id="coordinatorTelNo"
                                                    inputProps={{
                                                        ...register(
                                                            "coordinatorTelNo"
                                                        ),
                                                    }}
                                                    style={{ width: "65%" }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("coordinatorMobile") && (
                                            <Box
                                                display="flex"
                                                alignItems="baseline"
                                                marginBottom={5}
                                            >
                                                <InputLabel
                                                    htmlFor="coordinatorMobile"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "30%"
                                                                : "13%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.coordinatorMobile"
                                                    )}
                                                </InputLabel>
                                                <Box marginRight={2}>
                                                    {t("common.colon")}
                                                </Box>
                                                <CustomTextField
                                                    id="coordinatorMobile"
                                                    inputProps={{
                                                        ...register(
                                                            "coordinatorMobile"
                                                        ),
                                                    }}
                                                    style={{ width: "65%" }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("departmentName") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="departmentName"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "30%"
                                                                : "13%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.departmentName"
                                                    )}
                                                </InputLabel>
                                                <Box marginRight={2}>
                                                    {t("common.colon")}
                                                </Box>
                                                <CustomTextField
                                                    id="departmentName"
                                                    inputProps={{
                                                        ...register(
                                                            "departmentName"
                                                        ),
                                                    }}
                                                    style={{ width: "65%" }}
                                                />
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("signatureType") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="signatureType"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.signatureType"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "62.5%" }}>
                                                    <CustomSelect
                                                        control={control}
                                                        name="signatureType"
                                                        options={
                                                            signatureTypeOption
                                                        }
                                                        inlineText
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("jobTitle") && (
                                            <>
                                                <Box display="flex">
                                                    <InputLabel
                                                        htmlFor="jobTitle"
                                                        style={{
                                                            alignSelf: "center",
                                                            width:
                                                                i18n.language ===
                                                                "en"
                                                                    ? "18%"
                                                                    : "12%",
                                                        }}
                                                    >
                                                        {t(
                                                            "Form101.label.jobTitle"
                                                        )}
                                                        {t("common.colon")}
                                                    </InputLabel>
                                                    <Box
                                                        style={{
                                                            width: "62.5%",
                                                        }}
                                                    >
                                                        <Controller
                                                            control={control}
                                                            name="jobTitle"
                                                            render={({
                                                                field,
                                                            }) => (
                                                                <FormControl id="jobTitle">
                                                                    <Select
                                                                        label="jobTitle"
                                                                        inputProps={{
                                                                            "aria-labelledby":
                                                                                "jobTitle",
                                                                        }}
                                                                        value={
                                                                            field.value
                                                                        }
                                                                        displayEmpty
                                                                        native
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            field.onChange(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                            setSubjectOptions(
                                                                                form101SubjectOption(
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            );
                                                                            setSubject(
                                                                                ""
                                                                            );
                                                                            setValue(
                                                                                "subject",
                                                                                ""
                                                                            );
                                                                        }}
                                                                    >
                                                                        {Object.entries(
                                                                            form101JobOption()
                                                                        ).map(
                                                                            ([
                                                                                key,
                                                                                value,
                                                                            ]) => (
                                                                                <option
                                                                                    value={
                                                                                        key
                                                                                    }
                                                                                    key={
                                                                                        key
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        value
                                                                                    }
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Select>
                                                                </FormControl>
                                                            )}
                                                        />
                                                    </Box>
                                                </Box>
                                                <Box display="flex" marginY={3}>
                                                    <InputLabel
                                                        htmlFor="subject"
                                                        style={{
                                                            alignSelf: "center",
                                                            width:
                                                                i18n.language ===
                                                                "en"
                                                                    ? "18%"
                                                                    : "12%",
                                                        }}
                                                    >
                                                        {t(
                                                            "Form101.label.subject"
                                                        ) + t("common.colon")}
                                                    </InputLabel>
                                                    <Box
                                                        style={{
                                                            width: "62.5%",
                                                        }}
                                                    >
                                                        <Controller
                                                            control={control}
                                                            name="subject"
                                                            render={({
                                                                field,
                                                            }) => (
                                                                <FormControl id="subject">
                                                                    <Select
                                                                        label="subject"
                                                                        inputProps={{
                                                                            "aria-labelledby":
                                                                                "subject",
                                                                        }}
                                                                        value={
                                                                            subject
                                                                        }
                                                                        displayEmpty
                                                                        native
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            field.onChange(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                            setSubject(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                        }}
                                                                        disabled={
                                                                            Object.keys(
                                                                                subjectOptions
                                                                            )
                                                                                .length ===
                                                                            1
                                                                        }
                                                                    >
                                                                        {Object.entries(
                                                                            subjectOptions
                                                                        ).map(
                                                                            ([
                                                                                key,
                                                                                value,
                                                                            ]) => (
                                                                                <option
                                                                                    value={
                                                                                        key
                                                                                    }
                                                                                    key={
                                                                                        key
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        value
                                                                                    }
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Select>
                                                                </FormControl>
                                                            )}
                                                        />
                                                    </Box>
                                                </Box>
                                            </>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("amended") && (
                                            <Box display="flex" marginTop={3}>
                                                <InputLabel
                                                    htmlFor="amended"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.amended"
                                                    ) + t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "15%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="amended"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="amended"
                                                                style={{
                                                                    width: "50%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="amended"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "amended",
                                                                    }}
                                                                    value={
                                                                        field.value
                                                                    }
                                                                    native
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }}
                                                                >
                                                                    {Object.entries(
                                                                        t(
                                                                            "common.portal.amendedOptions",
                                                                            {
                                                                                returnObjects: true,
                                                                            }
                                                                        )
                                                                    ).map(
                                                                        ([
                                                                            key,
                                                                            value,
                                                                        ]) => (
                                                                            <option
                                                                                value={
                                                                                    key
                                                                                }
                                                                                key={
                                                                                    key
                                                                                }
                                                                            >
                                                                                {
                                                                                    value
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("sectionName") && (
                                            <Box display="flex">
                                                <InputLabel
                                                    htmlFor="sectionName"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "Form105.label.sectionName"
                                                    )}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "80%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="sectionName"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="sectionName"
                                                                style={{
                                                                    width: "100%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="sectionName"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "sectionName",
                                                                    }}
                                                                    value={
                                                                        field.value ||
                                                                        ""
                                                                    }
                                                                    displayEmpty
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }}
                                                                >
                                                                    <MenuItem value="">
                                                                        {t(
                                                                            "common.portal.all"
                                                                        )}
                                                                    </MenuItem>
                                                                    {isObjectNotEmpty(
                                                                        sectionNameOptions
                                                                    ) &&
                                                                        Object.entries(
                                                                            sectionNameOptions
                                                                        )
                                                                            .sort(
                                                                                (
                                                                                    [
                                                                                        keyA,
                                                                                    ],
                                                                                    [
                                                                                        keyB,
                                                                                    ]
                                                                                ) => {
                                                                                    // 根据英文名称排序，无论当前显示语言
                                                                                    const itemA =
                                                                                        allSectionNameList?.find(
                                                                                            (
                                                                                                item
                                                                                            ) =>
                                                                                                item.id ==
                                                                                                keyA
                                                                                        );
                                                                                    const itemB =
                                                                                        allSectionNameList?.find(
                                                                                            (
                                                                                                item
                                                                                            ) =>
                                                                                                item.id ==
                                                                                                keyB
                                                                                        );
                                                                                    const strA =
                                                                                        itemA?.sectionNameEn
                                                                                            ?.toString()
                                                                                            .toLowerCase() ||
                                                                                        "";
                                                                                    const strB =
                                                                                        itemB?.sectionNameEn
                                                                                            ?.toString()
                                                                                            .toLowerCase() ||
                                                                                        "";
                                                                                    return strA.localeCompare(
                                                                                        strB
                                                                                    );
                                                                                }
                                                                            )
                                                                            .map(
                                                                                ([
                                                                                    key,
                                                                                    value,
                                                                                ]) => (
                                                                                    <MenuItem
                                                                                        value={
                                                                                            key
                                                                                        }
                                                                                        key={
                                                                                            key
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            value
                                                                                        }
                                                                                    </MenuItem>
                                                                                )
                                                                            )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("rejectedBy") && (
                                            <Box display="flex" marginTop={3}>
                                                <InputLabel
                                                    htmlFor="rejectedBy"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.rejectedBy"
                                                    ) + t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "30%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="rejectedBy"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="rejectedBy"
                                                                style={{
                                                                    width: "50%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="rejectedBy"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "rejectedBy",
                                                                    }}
                                                                    value={
                                                                        field.value ||
                                                                        ""
                                                                    }
                                                                    native
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                        if (
                                                                            isNotEmpty(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        ) {
                                                                            setValue(
                                                                                "status",
                                                                                "21"
                                                                            );
                                                                        } else {
                                                                            setValue(
                                                                                "status",
                                                                                ""
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="">
                                                                        {t(
                                                                            "common.portal.all"
                                                                        )}
                                                                    </option>
                                                                    {Object.entries(
                                                                        t(
                                                                            "common.portal.rejectedOptions",
                                                                            {
                                                                                returnObjects: true,
                                                                            }
                                                                        )
                                                                    ).map(
                                                                        ([
                                                                            key,
                                                                            value,
                                                                        ]) => (
                                                                            <option
                                                                                value={
                                                                                    key
                                                                                }
                                                                                key={
                                                                                    key
                                                                                }
                                                                            >
                                                                                {
                                                                                    value
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {getAdvSearchFeilds(
                                            formId?.formId
                                        )?.includes("createdOrgId") && (
                                            <Box display="flex" marginTop={3}>
                                                <InputLabel
                                                    htmlFor="createdOrgId"
                                                    style={{
                                                        alignSelf: "center",
                                                        width:
                                                            i18n.language ===
                                                            "en"
                                                                ? "18%"
                                                                : "12%",
                                                    }}
                                                >
                                                    {t("common.schoolName")}
                                                    {t("common.colon")}
                                                </InputLabel>
                                                <Box style={{ width: "65%" }}>
                                                    <Controller
                                                        control={control}
                                                        name="createdOrgId"
                                                        render={({ field }) => (
                                                            <FormControl
                                                                id="createdOrgId"
                                                                style={{
                                                                    width: "100%",
                                                                }}
                                                            >
                                                                <Select
                                                                    label="createdOrgId"
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            "createdOrgId",
                                                                    }}
                                                                    value={
                                                                        field.value ||
                                                                        ""
                                                                    }
                                                                    displayEmpty
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }}
                                                                >
                                                                    <MenuItem value="">
                                                                        {t(
                                                                            "common.portal.all"
                                                                        )}
                                                                    </MenuItem>
                                                                    {isObjectNotEmpty(
                                                                        postSecondaryOptions
                                                                    ) &&
                                                                        Object.entries(
                                                                            postSecondaryOptions
                                                                        )
                                                                            .sort(
                                                                                (
                                                                                    [
                                                                                        keyA,
                                                                                    ],
                                                                                    [
                                                                                        keyB,
                                                                                    ]
                                                                                ) => {
                                                                                    const strA =
                                                                                        postSecondaryOptions[
                                                                                            keyA
                                                                                        ]
                                                                                            ?.toString()
                                                                                            .toLowerCase() ||
                                                                                        "";
                                                                                    const strB =
                                                                                        postSecondaryOptions[
                                                                                            keyB
                                                                                        ]
                                                                                            ?.toString()
                                                                                            .toLowerCase() ||
                                                                                        "";
                                                                                    return strA.localeCompare(
                                                                                        strB
                                                                                    );
                                                                                }
                                                                            )
                                                                            .map(
                                                                                ([
                                                                                    key,
                                                                                    value,
                                                                                ]) => (
                                                                                    <MenuItem
                                                                                        value={
                                                                                            key
                                                                                        }
                                                                                        key={
                                                                                            key
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            value
                                                                                        }
                                                                                    </MenuItem>
                                                                                )
                                                                            )}
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {formId?.formId !== "Form104" && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{
                                                    marginLeft:
                                                        i18n.language === "en"
                                                            ? isMobile
                                                                ? "6rem"
                                                                : "9rem"
                                                            : "6.6rem",
                                                    marginTop: "5px",
                                                }}
                                                onClick={() => {
                                                    const advSearchFeilds =
                                                        getAdvSearchFeilds(
                                                            formId?.formId
                                                        );
                                                    advSearchFeilds.forEach(
                                                        (feild) => {
                                                            setValue(
                                                                feild,
                                                                "",
                                                                {
                                                                    shouldValidate: true,
                                                                }
                                                            );
                                                        }
                                                    );
                                                    //Form101 clear use state
                                                    if (
                                                        formId?.formId ===
                                                        "Form101"
                                                    ) {
                                                        setSubject("");
                                                        setSubjectOptions(
                                                            form101SubjectOption(
                                                                ""
                                                            )
                                                        );
                                                    }
                                                }}
                                            >
                                                {t("common.button.clear")}
                                            </Button>
                                        )}
                                    </Box>
                                )}

                            <br />
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    marginLeft:
                                        i18n.language === "en"
                                            ? isMobile
                                                ? "6rem"
                                                : "9rem"
                                            : "6.6rem",
                                }}
                                onClick={onSubmit}
                            >
                                {t("common.search")}
                            </Button>
                            <CustomTooltip
                                title={t("common.portal.formSelectTooltip")}
                            />
                            <Box style={{ float: "right" }}>
                                {isEDBUser && formId?.formId === "Form101" && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={getFullExcel}
                                    >
                                        {t("common.portal.genExcel")}
                                    </Button>
                                )}
                                {isEDBUser && formId?.formId === "Form107" && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={getForm107Zip}
                                    >
                                        {t("common.portal.genExcel")}
                                    </Button>
                                )}
                                {!selectedUserOrg?.isPostSecondary && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={isObjectEmpty(searchResult)}
                                        style={{
                                            marginLeft: isMobile ? "0" : "5rem",
                                            float: "right",
                                        }}
                                        onClick={() => getZip()}
                                    >
                                        {isIncludeBatchDownload(searchFormId)
                                            ? t("common.portal.batchDownload")
                                            : t("common.portal.download") +
                                              " PDF"}
                                    </Button>
                                )}
                            </Box>
                            {isEDBUser && formId?.formId === "Form028" && (
                                <Box
                                    style={{ float: "right" }}
                                    my={
                                        i18n.language !== "en" && !isMobile
                                            ? 0
                                            : 4
                                    }
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            downloadURLFile(
                                                process.env.PUBLIC_URL +
                                                    `/formFiles/Form028/`,
                                                `Form028_Batch_Review.xlsx`,
                                                dispatch
                                            )
                                        }
                                        style={{}}
                                    >
                                        {t("common.portal.downloadTemplate")}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            setForm028Dialog(true);
                                        }}
                                        style={{
                                            marginLeft: "5px",
                                        }}
                                    >
                                        {t(
                                            "common.portal.applicationStatusUpdate"
                                        )}
                                    </Button>
                                </Box>
                            )}
                            {isIncludeBatchDownload(searchFormId) &&
                                isEDBUser &&
                                isObjectNotEmpty(formId?.formId) &&
                                formId?.formId !== "Form101" &&
                                formId?.formId !== "Form107" && (
                                    <Box mt={6} mb={6}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{
                                                marginBottom: "10px",
                                                float: "right",
                                            }}
                                            onClick={() => getExcelZip()}
                                        >
                                            {t(
                                                "common.portal.batchDownloadExcel"
                                            )}
                                        </Button>
                                    </Box>
                                )}
                        </Box>
                        <br />
                        <Dialog
                            onClose={() => setForm028Dialog(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            open={form028Dialog}
                            fullWidth={true}
                        >
                            <DialogContent id="alert-dialog-title">
                                <DialogContentText id="upload-file-description">
                                    <b>
                                        {t(
                                            "common.portal.uploadCompletedTemplateTitle"
                                        )}
                                    </b>
                                    <br />
                                    <br />

                                    {!form028SelectedUploadFile && (
                                        <Button
                                            variant="outlined"
                                            component="label"
                                        >
                                            {t(
                                                "common.portal.uploadCompletedTemplate"
                                            )}
                                            <input
                                                hidden
                                                accept=".xls,.xlsx"
                                                type="file"
                                                onChange={(event) => {
                                                    const file =
                                                        event.target.files &&
                                                        event.target.files[0];
                                                    if (file) {
                                                        setForm028SelectedUploadFile(
                                                            file
                                                        );
                                                    }
                                                }}
                                            />
                                        </Button>
                                    )}

                                    {form028SelectedUploadFile && (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginTop: "8px",
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                style={{ marginRight: "8px" }}
                                            >
                                                {form028SelectedUploadFile.name}
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                    setForm028SelectedUploadFile(
                                                        null
                                                    )
                                                }
                                            >
                                                {t("common.remove")}
                                            </Button>
                                        </div>
                                    )}
                                    <Tooltip
                                        disableHoverListener={true}
                                        open={form028UploadTipsOpen}
                                        title={
                                            <Typography color="inherit">
                                                {t(
                                                    "common.portal.uploadCompletedTemplateTips"
                                                )}
                                            </Typography>
                                        }
                                        style={{ maxWidth: "500px" }}
                                    >
                                        <Button
                                            tabIndex="0"
                                            style={{
                                                padding: 0,
                                                textTransform: "none",
                                            }}
                                            onClick={(e) => {
                                                setForm028UploadTipsOpen(
                                                    !form028UploadTipsOpen
                                                );
                                                e.stopPropagation();
                                            }}
                                        >
                                            <InfoIcon
                                                className={classes.colorInherit}
                                            />
                                            <span>
                                                {t("common.portal.uploadRules")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={() => {
                                        setForm028Dialog(false);
                                        setForm028SelectedUploadFile(null);
                                    }}
                                >
                                    {t("common.portal.cancelUploadFile")}
                                </Button>
                                <Button
                                    onClick={() => {
                                        uploadFiles(form028SelectedUploadFile);
                                    }}
                                >
                                    {t("common.portal.submitUploadFile")}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <AlertDialog
                            formOpen={form028UploadResultDialog}
                            content={
                                form028UploadAllFail
                                    ? form028UploadFileErrorCode
                                    : form028UpdatedFailFormRefs.length === 0
                                    ? t("common.portal.uploadResultAllSuccess")
                                    : t("common.portal.uploadResultHasFail", {
                                          failFormRefs:
                                              form028UpdatedFailFormRefs,
                                      })
                            }
                            confirmButton={{
                                action: () => {
                                    setForm028UploadResultDialog(false);
                                    setForm028UpdatedFailFormRefs([]);
                                    setForm028UploadAllFail(false);
                                    setForm028UploadFileErrorCode(null);
                                },
                                label: t("common.portal.confirmUploadResult"),
                            }}
                        />
                        <TableContainer component={Paper}>
                            <Table
                                stickyHeader
                                size="small"
                                aria-label="a dense table"
                                component={"div"}
                                classes={{
                                    root: `${
                                        isIncludeBatchDownload(searchFormId)
                                            ? classes.customTable
                                            : ""
                                    }`,
                                }}
                            >
                                <TableHead component={"div"}>
                                    <TableRow component={"div"}>
                                        {isIncludeBatchDownload(
                                            searchFormId
                                        ) && (
                                            <TableCell
                                                align="center"
                                                style={{
                                                    width: "12%",
                                                }}
                                            >
                                                <Box
                                                    style={{
                                                        fontWeight: "bold",
                                                        marginBottom: "-8px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                    component={"div"}
                                                >
                                                    {t(
                                                        `common.portal.selectAll`
                                                    )}
                                                </Box>

                                                <Checkbox
                                                    color="primary"
                                                    indeterminate={
                                                        selected?.length > 0 &&
                                                        selected?.length <
                                                            searchResult?.length
                                                    }
                                                    checked={
                                                        searchResult?.length >
                                                            0 &&
                                                        selected?.length != 0 &&
                                                        selected?.length ===
                                                            searchResult?.filter(
                                                                (item) =>
                                                                    item.viewPermission ===
                                                                    true
                                                            ).length
                                                    }
                                                    onChange={
                                                        handleSelectAllClick
                                                    }
                                                    inputProps={{
                                                        "aria-label":
                                                            "select all desserts",
                                                    }}
                                                />
                                            </TableCell>
                                        )}
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                            component={"div"}
                                        >
                                            {/* Reference No. / Batch No. */}
                                            {(isEDBUser &&
                                                formId?.formId === "Form107") ||
                                            selectedUserOrg?.isPostSecondary
                                                ? i18n.language === "en"
                                                    ? "Batch No."
                                                    : t("common.portal.batchNo")
                                                : i18n.language === "en"
                                                ? "Reference No."
                                                : t(
                                                      "common.portal.referenceNum"
                                                  )}
                                        </TableCell>
                                        {!selectedUserOrg?.isPostSecondary && (
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: isIncludeBatchDownload(
                                                        searchFormId
                                                    )
                                                        ? "40%"
                                                        : "60%",
                                                }}
                                                component={"div"}
                                            >
                                                {isEDBUser &&
                                                formId?.formId === "Form107"
                                                    ? i18n.language === "en"
                                                        ? "School"
                                                        : t(
                                                              "common.portal.school"
                                                          )
                                                    : i18n.language === "en"
                                                    ? "Form"
                                                    : "表格"}
                                            </TableCell>
                                        )}
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                                width: isIncludeBatchDownload(
                                                    searchFormId
                                                )
                                                    ? "15%"
                                                    : "30%",
                                            }}
                                            component={"div"}
                                        >
                                            {t("common.portal.status")}
                                        </TableCell>
                                        {((isEDBUser &&
                                            isIncludeBatchDownload(
                                                searchFormId
                                            )) ||
                                            selectedUserOrg?.isPostSecondary) && (
                                            <TableCell align="center">
                                                <Button
                                                    variant="text"
                                                    style={{
                                                        fontWeight: "bold",
                                                        lineHeight: "1.2",
                                                        whiteSpace: "pre-line",
                                                        fontSize: "0.875rem",
                                                        textTransform: "none",
                                                    }}
                                                    component={"div"}
                                                    onClick={() => {
                                                        sortingAttribute(
                                                            "submission"
                                                        );
                                                    }}
                                                >
                                                    {t(
                                                        `common.portal.formSubmissionDateTime`
                                                    )
                                                        .split("<br/>")
                                                        .join("\n")}
                                                    {defaultSorting != 1 ? (
                                                        <ImportExportSharp
                                                            style={{
                                                                opacity: "0.3",
                                                            }}
                                                        />
                                                    ) : sortingObject.find(
                                                          (item) =>
                                                              item.attribute ===
                                                              "submission"
                                                      ).order === "desc" ? (
                                                        <ArrowDropDown
                                                            style={{
                                                                opacity: "1",
                                                            }}
                                                        />
                                                    ) : (
                                                        <ArrowDropUp
                                                            style={{
                                                                opacity: "1",
                                                            }}
                                                        />
                                                    )}
                                                </Button>
                                            </TableCell>
                                        )}
                                        {((isEDBUser &&
                                            formId?.formId === "Form107") ||
                                            selectedUserOrg?.isPostSecondary) && (
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                                component={"div"}
                                            >
                                                {t("common.portal.lastUpdate")}
                                            </TableCell>
                                        )}
                                        {isEDBUser &&
                                            isIncludeBatchDownload(
                                                searchFormId
                                            ) && (
                                                <TableCell align="center">
                                                    <Button
                                                        variant="text"
                                                        style={{
                                                            fontWeight: "bold",
                                                            lineHeight: "1.2",
                                                            whiteSpace:
                                                                "pre-line",
                                                            fontSize:
                                                                "0.875rem",
                                                            textTransform:
                                                                "none",
                                                        }}
                                                        component={"div"}
                                                        onClick={() => {
                                                            sortingAttribute(
                                                                "downloaded"
                                                            );
                                                        }}
                                                    >
                                                        {t(
                                                            `common.portal.formDownloaded`
                                                        )
                                                            .split("<br/>")
                                                            .join("\n")}
                                                        {defaultSorting != 2 ? (
                                                            <ImportExportSharp
                                                                style={{
                                                                    opacity:
                                                                        "0.3",
                                                                }}
                                                            />
                                                        ) : sortingObject.find(
                                                              (item) =>
                                                                  item.attribute ===
                                                                  "downloaded"
                                                          ).order === "desc" ? (
                                                            <ArrowDropDown
                                                                style={{
                                                                    opacity:
                                                                        "1",
                                                                }}
                                                            />
                                                        ) : (
                                                            <ArrowDropUp
                                                                style={{
                                                                    opacity:
                                                                        "1",
                                                                }}
                                                            />
                                                        )}
                                                    </Button>
                                                </TableCell>
                                            )}
                                    </TableRow>
                                </TableHead>

                                {!isObjectEmpty(searchResult) && (
                                    <TableBody component={"div"}>
                                        {searchResult.map((item, index) => {
                                            const isItemSelected = isSelected(
                                                item.formRefNum
                                            );
                                            const labelId = `enhanced-table-checkbox-${index}`;
                                            return (
                                                <Fragment key={item.formRefNum}>
                                                    <TableRow
                                                        key={item.formRefNum}
                                                        component={"div"}
                                                        style={{
                                                            cursor: "pointer",
                                                        }}
                                                        // to={`/approval/Form${item.formId.padStart(
                                                        //     3,
                                                        //     "0"
                                                        // )}/${item.formRefNum}`}
                                                        className={
                                                            classes.tableRow
                                                        }
                                                        onClick={() => {
                                                            handleToDetail(
                                                                item
                                                            );
                                                        }}
                                                    >
                                                        {isIncludeBatchDownload(
                                                            searchFormId
                                                        ) && (
                                                            <TableCell
                                                                align="center"
                                                                component={
                                                                    "div"
                                                                }
                                                            >
                                                                <Checkbox
                                                                    color="primary"
                                                                    checked={
                                                                        isItemSelected
                                                                    }
                                                                    inputProps={{
                                                                        "aria-labelledby":
                                                                            labelId,
                                                                    }}
                                                                    onClick={(
                                                                        event
                                                                    ) => {
                                                                        handleClick(
                                                                            event,
                                                                            item.formRefNum
                                                                        );
                                                                        event.stopPropagation();
                                                                    }}
                                                                    disabled={
                                                                        !item?.viewPermission
                                                                    }
                                                                />
                                                            </TableCell>
                                                        )}
                                                        <TableCell
                                                            align="center"
                                                            component={"div"}
                                                        >
                                                            {item.formRefNum}
                                                        </TableCell>
                                                        {!selectedUserOrg?.isPostSecondary && (
                                                            <TableCell
                                                                align="center"
                                                                component={
                                                                    "div"
                                                                }
                                                            >
                                                                {isEDBUser &&
                                                                formId?.formId ===
                                                                    "Form107"
                                                                    ? item.schoolName ||
                                                                      t(
                                                                          "common.na",
                                                                          "N/A"
                                                                      )
                                                                    : t(
                                                                          `form.Form${item.formId.padStart(
                                                                              3,
                                                                              "0"
                                                                          )}`,
                                                                          // item.titleParam
                                                                          getEnquiryTitleParam(
                                                                              item.formId,
                                                                              item.titleParam,
                                                                              i18n.language
                                                                          )
                                                                      )}
                                                            </TableCell>
                                                        )}
                                                        <TableCell
                                                            align="center"
                                                            component={"div"}
                                                        >
                                                            {getStatusPerForm(
                                                                item.formId,
                                                                item.status
                                                            )}
                                                        </TableCell>
                                                        {((isEDBUser &&
                                                            isIncludeBatchDownload(
                                                                searchFormId
                                                            )) ||
                                                            selectedUserOrg?.isPostSecondary) && (
                                                            <TableCell
                                                                align="center"
                                                                component={
                                                                    "div"
                                                                }
                                                            >
                                                                {isObjectEmpty(
                                                                    item.formattedSubmissionTime
                                                                )
                                                                    ? isObjectEmpty(
                                                                          item.submissionTime
                                                                      )
                                                                        ? t(
                                                                              "common.na"
                                                                          )
                                                                        : item.submissionTime
                                                                    : item.formattedSubmissionTime}
                                                            </TableCell>
                                                        )}
                                                        {((isEDBUser &&
                                                            formId?.formId ===
                                                                "Form107") ||
                                                            selectedUserOrg?.isPostSecondary) && (
                                                            <TableCell
                                                                align="center"
                                                                component={
                                                                    "div"
                                                                }
                                                            >
                                                                {item.lastModifiedDateTime
                                                                    ? moment(
                                                                          item.lastModifiedDateTime
                                                                      ).format(
                                                                          "DD/MM/YYYY HH:mm"
                                                                      )
                                                                    : t(
                                                                          "common.na"
                                                                      )}
                                                            </TableCell>
                                                        )}
                                                        {isEDBUser &&
                                                            isIncludeBatchDownload(
                                                                searchFormId
                                                            ) && (
                                                                <TableCell
                                                                    align="center"
                                                                    component={
                                                                        "div"
                                                                    }
                                                                >
                                                                    {item.downloaded ===
                                                                    true
                                                                        ? t(
                                                                              "common.portal.yes"
                                                                          )
                                                                        : t(
                                                                              "common.portal.no"
                                                                          )}
                                                                </TableCell>
                                                            )}
                                                    </TableRow>

                                                    {isEDBUser &&
                                                        isNotEmpty(
                                                            getAdvSearchFeilds(
                                                                advSearchFormId
                                                            )
                                                        ) &&
                                                        (formId?.formId ===
                                                        "Form105"
                                                            ? true
                                                            : hasRowValue(
                                                                  item
                                                              )) && (
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={
                                                                        isIncludeBatchDownload(
                                                                            searchFormId
                                                                        )
                                                                            ? 6
                                                                            : 3
                                                                    }
                                                                    style={{
                                                                        paddingLeft:
                                                                            "30px",
                                                                    }}
                                                                >
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "scrn"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {formId?.formId ===
                                                                                "Form104"
                                                                                    ? t(
                                                                                          "Form104.label.scrn"
                                                                                      )
                                                                                    : t(
                                                                                          "common.portal.scrn"
                                                                                      )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.scrn
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.scrn
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {/*{getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "submissionTime"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.submissionDate"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.submissionTime
                                                                            ) ? (
                                                                                Constant?.advSearchResultSubmissionTimeDateFormat?.includes(
                                                                                    advSearchFormId
                                                                                ) ? (
                                                                                    <span>
                                                                                        {moment(
                                                                                            item.submissionTime
                                                                                        ).format(
                                                                                            i18n.language ==
                                                                                                "en"
                                                                                                ? "YYYY-MM-DD HH:mm:ss"
                                                                                                : "YYYY年MM月DD日 HH:mm:ss"
                                                                                        )}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span>
                                                                                        {moment(
                                                                                            item.submissionTime
                                                                                        ).format(
                                                                                            i18n.language ==
                                                                                                "en"
                                                                                                ? "YYYY-MM-DD"
                                                                                                : "YYYY年MM月DD日"
                                                                                        )}
                                                                                    </span>
                                                                                )
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}*/}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "treaSchlCode"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.schoolCode"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.treaSchlCode
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.treaSchlCode
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "nameOfContributorEN"
                                                                    ) && (
                                                                        <Grid
                                                                            container
                                                                        >
                                                                            <Grid
                                                                                item
                                                                            >
                                                                                {t(
                                                                                    "common.nameOfContributorEN"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </Grid>
                                                                            {isNotEmpty(
                                                                                item.expandField1
                                                                            ) ? (
                                                                                <Grid
                                                                                    item
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: item.expandField1,
                                                                                    }}
                                                                                ></Grid>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </Grid>
                                                                    )}

                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "nameOfContributorCH"
                                                                    ) && (
                                                                        <Grid
                                                                            container
                                                                        >
                                                                            <Grid
                                                                                item
                                                                            >
                                                                                {t(
                                                                                    "common.nameOfContributorCH"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </Grid>
                                                                            {isNotEmpty(
                                                                                item.expandField2
                                                                            ) ? (
                                                                                <Grid
                                                                                    item
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: item.expandField2,
                                                                                    }}
                                                                                ></Grid>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </Grid>
                                                                    )}

                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "telNo"
                                                                    ) &&
                                                                        (formId?.formId ===
                                                                            "Form092" ||
                                                                            formId?.formId ===
                                                                                "Form095") && (
                                                                            <Grid
                                                                                container
                                                                            >
                                                                                <Grid
                                                                                    item
                                                                                >
                                                                                    {t(
                                                                                        "common.telNo"
                                                                                    )}
                                                                                    {t(
                                                                                        "common.colon"
                                                                                    )}
                                                                                </Grid>
                                                                                {isNotEmpty(
                                                                                    item.expandField3
                                                                                ) ? (
                                                                                    <Grid
                                                                                        item
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: item.expandField3,
                                                                                        }}
                                                                                    ></Grid>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                )}
                                                                            </Grid>
                                                                        )}

                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "schoolName"
                                                                    ) && (
                                                                        <Grid
                                                                            container
                                                                        >
                                                                            <Grid
                                                                                item
                                                                            >
                                                                                {formId?.formId ===
                                                                                    "Form092" ||
                                                                                formId?.formId ===
                                                                                    "Form095"
                                                                                    ? t(
                                                                                          "common.lastSchoolOfEmployment"
                                                                                      )
                                                                                    : t(
                                                                                          "common.schoolName"
                                                                                      )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </Grid>
                                                                            {formId?.formId !==
                                                                                "Form092" &&
                                                                                formId?.formId !==
                                                                                    "Form095" &&
                                                                                (isNotEmpty(
                                                                                    item.schoolName
                                                                                ) ? (
                                                                                    <Grid
                                                                                        item
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: item.schoolName,
                                                                                        }}
                                                                                    ></Grid>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                ))}
                                                                            {(formId?.formId ===
                                                                                "Form092" ||
                                                                                formId?.formId ===
                                                                                    "Form095") &&
                                                                                (isNotEmpty(
                                                                                    item.schoolName
                                                                                ) ||
                                                                                isNotEmpty(
                                                                                    item.schoolNameTc
                                                                                ) ? (
                                                                                    <Grid
                                                                                        item
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html:
                                                                                                (i18n.language ===
                                                                                                "en"
                                                                                                    ? item.schoolName
                                                                                                    : item.schoolNameTc) ||
                                                                                                item.schoolName,
                                                                                        }}
                                                                                    ></Grid>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                ))}
                                                                        </Grid>
                                                                    )}

                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "staffNo"
                                                                    ) && (
                                                                        <Grid
                                                                            container
                                                                        >
                                                                            <Grid
                                                                                item
                                                                            >
                                                                                {t(
                                                                                    "common.staffNo"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </Grid>
                                                                            {isNotEmpty(
                                                                                item.expandField4
                                                                            ) ? (
                                                                                <Grid
                                                                                    item
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: item.expandField4,
                                                                                    }}
                                                                                ></Grid>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </Grid>
                                                                    )}

                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "applicantName"
                                                                    ) &&
                                                                        (Constant?.advSearchResultExpandApplicantName?.includes(
                                                                            advSearchFormId
                                                                        ) ? (
                                                                            <>
                                                                                <p>
                                                                                    <span>
                                                                                        {t(
                                                                                            "common.portal.applicantCnName"
                                                                                        )}
                                                                                        {t(
                                                                                            "common.colon"
                                                                                        )}
                                                                                    </span>
                                                                                    {isNotEmpty(
                                                                                        item.expandField2
                                                                                    ) ? (
                                                                                        <span>
                                                                                            {
                                                                                                item.expandField2
                                                                                            }
                                                                                        </span>
                                                                                    ) : (
                                                                                        t(
                                                                                            "common.na",
                                                                                            "N/A"
                                                                                        )
                                                                                    )}
                                                                                </p>
                                                                                <p>
                                                                                    <span>
                                                                                        {t(
                                                                                            "common.portal.applicantEnName"
                                                                                        )}
                                                                                        {t(
                                                                                            "common.colon"
                                                                                        )}
                                                                                    </span>
                                                                                    {isNotEmpty(
                                                                                        item.expandField1
                                                                                    ) ? (
                                                                                        <span>
                                                                                            {
                                                                                                item.expandField1
                                                                                            }
                                                                                        </span>
                                                                                    ) : (
                                                                                        t(
                                                                                            "common.na",
                                                                                            "N/A"
                                                                                        )
                                                                                    )}
                                                                                </p>
                                                                            </>
                                                                        ) : Constant?.advSearchResultExpandFullApplicantName?.includes(
                                                                              advSearchFormId
                                                                          ) ? (
                                                                            <p>
                                                                                <span>
                                                                                    {t(
                                                                                        "common.portal.applicantName"
                                                                                    )}
                                                                                    {t(
                                                                                        "common.colon"
                                                                                    )}
                                                                                </span>
                                                                                {isNotEmpty(
                                                                                    item.expandField1
                                                                                ) ? (
                                                                                    <span>
                                                                                        {
                                                                                            item.expandField1
                                                                                        }
                                                                                    </span>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                )}
                                                                            </p>
                                                                        ) : (
                                                                            <p>
                                                                                <span>
                                                                                    {t(
                                                                                        "common.portal.applicantName"
                                                                                    )}
                                                                                    {t(
                                                                                        "common.colon"
                                                                                    )}
                                                                                </span>
                                                                                {isNotEmpty(
                                                                                    item.applicantName
                                                                                ) ? (
                                                                                    <span>
                                                                                        {
                                                                                            item.applicantName
                                                                                        }
                                                                                    </span>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                )}
                                                                            </p>
                                                                        ))}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "telNo"
                                                                    ) &&
                                                                        formId?.formId ===
                                                                            "Form075" && (
                                                                            <p>
                                                                                <span>
                                                                                    {t(
                                                                                        "common.portal.schltele"
                                                                                    )}
                                                                                    {t(
                                                                                        "common.colon"
                                                                                    )}
                                                                                </span>
                                                                                {isNotEmpty(
                                                                                    item.expandField1
                                                                                ) ? (
                                                                                    <span>
                                                                                        {
                                                                                            item.expandField1
                                                                                        }
                                                                                    </span>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                )}
                                                                            </p>
                                                                        )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "schltele"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.schltele"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.schltele
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.schltele
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "schlLevlType"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.schoolLevel"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.schlLevlType
                                                                            ) ? (
                                                                                <span>
                                                                                    {t(
                                                                                        `common.schoolLevelOption.${item.schlLevlType}`
                                                                                    )}
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "schlFinanceTpye"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.financeType"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.schlFinanceTpye
                                                                            ) ? (
                                                                                <span>
                                                                                    {t(
                                                                                        `common.fullSchoolFinanceTypeOption.${item.schlFinanceTpye}`
                                                                                    )}
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "signatureType"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.signatureType"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                signatureTypeOption?.[
                                                                                    item
                                                                                        .signatureType
                                                                                ]
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        signatureTypeOption?.[
                                                                                            item
                                                                                                .signatureType
                                                                                        ]
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "ngoNameEng"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.ngoNameEng"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.ngoNameEng
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.ngoNameEng
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "ngoNameChi"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.ngoNameChi"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.ngoNameChi
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.ngoNameChi
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "coordinatorName"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.coordinatorName"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.coordinatorName
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.coordinatorName
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "coordinatorTelNo"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.coordinatorTelNo"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.coordinatorTelNo
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.coordinatorTelNo
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "coordinatorMobile"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.coordinatorMobile"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item.coordinatorMobile
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item.coordinatorMobile
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "departmentName"
                                                                    ) && (
                                                                        <Box>
                                                                            <p>
                                                                                <span>
                                                                                    {t(
                                                                                        "common.portal.departmentNameEng"
                                                                                    )}
                                                                                    {t(
                                                                                        "common.colon"
                                                                                    )}
                                                                                </span>
                                                                                {isNotEmpty(
                                                                                    item.departmentNameEng
                                                                                ) ? (
                                                                                    <span>
                                                                                        {
                                                                                            item.departmentNameEng
                                                                                        }
                                                                                    </span>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                )}
                                                                            </p>
                                                                            <p>
                                                                                <span>
                                                                                    {t(
                                                                                        "common.portal.departmentNameChi"
                                                                                    )}
                                                                                    {t(
                                                                                        "common.colon"
                                                                                    )}
                                                                                </span>
                                                                                {isNotEmpty(
                                                                                    item.departmentNameChi
                                                                                ) ? (
                                                                                    <span>
                                                                                        {
                                                                                            item.departmentNameChi
                                                                                        }
                                                                                    </span>
                                                                                ) : (
                                                                                    t(
                                                                                        "common.na",
                                                                                        "N/A"
                                                                                    )
                                                                                )}
                                                                            </p>
                                                                        </Box>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "subject"
                                                                    ) && (
                                                                        <Box
                                                                            display={
                                                                                "flex"
                                                                            }
                                                                            flexDirection={
                                                                                "row"
                                                                            }
                                                                        >
                                                                            <Box>
                                                                                {t(
                                                                                    "Form101.stepName.post"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </Box>
                                                                            {isNotEmpty(
                                                                                item.subject
                                                                            ) ? (
                                                                                <Box>
                                                                                    {Object.keys(
                                                                                        item.subject
                                                                                    )?.map(
                                                                                        (
                                                                                            jobKey
                                                                                        ) =>
                                                                                            isNotEmpty(
                                                                                                item
                                                                                                    .subject?.[
                                                                                                    jobKey
                                                                                                ]
                                                                                            ) ? (
                                                                                                item.subject?.[
                                                                                                    jobKey
                                                                                                ]?.map(
                                                                                                    (
                                                                                                        subject,

                                                                                                        subjectIndex
                                                                                                    ) => (
                                                                                                        <Box
                                                                                                            key={
                                                                                                                subjectIndex
                                                                                                            }
                                                                                                        >
                                                                                                            {`${
                                                                                                                form101JobOption()?.[
                                                                                                                    jobKey
                                                                                                                ]
                                                                                                            }(${
                                                                                                                form101SubjectOption(
                                                                                                                    jobKey
                                                                                                                )?.[
                                                                                                                    subject
                                                                                                                ]
                                                                                                            })`}
                                                                                                        </Box>
                                                                                                    )
                                                                                                )
                                                                                            ) : (
                                                                                                <Box
                                                                                                    key={
                                                                                                        jobKey
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        form101JobOption()?.[
                                                                                                            jobKey
                                                                                                        ]
                                                                                                    }
                                                                                                </Box>
                                                                                            )
                                                                                    )}
                                                                                </Box>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </Box>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "amended"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.amended"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            <span>
                                                                                {isNotEmpty(
                                                                                    item.version
                                                                                ) &&
                                                                                item.version >
                                                                                    0
                                                                                    ? t(
                                                                                          `common.portal.amendedOptions.yes`
                                                                                      )
                                                                                    : t(
                                                                                          `common.portal.amendedOptions.no`
                                                                                      )}
                                                                            </span>
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "version"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.version"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {
                                                                                item.version
                                                                            }
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "sectionName"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "Form105.label.sectionName"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item?.[
                                                                                    `sectionName${capitalizeFirstLetter(
                                                                                        i18n.language
                                                                                    )}`
                                                                                ]
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item?.[
                                                                                            `sectionName${capitalizeFirstLetter(
                                                                                                i18n.language
                                                                                            )}`
                                                                                        ]
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "group"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.responsibleGroup"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                item?.[
                                                                                    `group${capitalizeFirstLetter(
                                                                                        i18n.language
                                                                                    )}`
                                                                                ]
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        item?.[
                                                                                            `group${capitalizeFirstLetter(
                                                                                                i18n.language
                                                                                            )}`
                                                                                        ]
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                    {getAdvSearchFeilds(
                                                                        advSearchFormId
                                                                    )?.includes(
                                                                        "rejectedBy"
                                                                    ) && (
                                                                        <p>
                                                                            <span>
                                                                                {t(
                                                                                    "common.portal.rejectedBy"
                                                                                )}
                                                                                {t(
                                                                                    "common.colon"
                                                                                )}
                                                                            </span>
                                                                            {isNotEmpty(
                                                                                rejectedOptions?.[
                                                                                    item
                                                                                        .rejectedBy
                                                                                ]
                                                                            ) ? (
                                                                                <span>
                                                                                    {
                                                                                        rejectedOptions?.[
                                                                                            item
                                                                                                .rejectedBy
                                                                                        ]
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                t(
                                                                                    "common.na",
                                                                                    "N/A"
                                                                                )
                                                                            )}
                                                                        </p>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                </Fragment>
                                            );
                                        })}
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={total}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={offset}
                            rowsPerPageOptions={[offset]}
                            labelDisplayedRows={({ from, to, count }) =>
                                i18n.language === "tc"
                                    ? `${count}個項目的 第${from}-${to}個`
                                    : i18n.language === "sc"
                                    ? `${count}个项目的 第${from}-${to}个`
                                    : `${from}-${to} of ${count}`
                            }
                        />
                    </Box>
                </main>
            </Box>
        </Container>
    );
}

export default FormEnquiry;
